import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import axios from "axios";
import { Form } from "informed";
import "firebase/auth";
import { TextInput } from "../shared/Forms";
import Loader from "../ui/Loader";
import * as constants from "../../constants";

const eventId = "e3172a95-6ed1-4f1b-a541-9744f6d1a15b";
const apiKey = "mn4bf4dc7kr9yv7p:";

const bf = axios.create({
	baseURL: "https://api.brushfire.com",
	timeout: 20000,
	headers: { Authorization: "Basic " + btoa(apiKey), "Api-Version": "2018-10-10" },
});

class BreakForthOneSchedule extends Component {
	constructor(props) {
		super(props);
		this.userId = props.match.params.userId;
		this.appKey = props.match.params.appKey;
		let email = localStorage.getItem("bfoEmail");
		let attendeeNumber = localStorage.getItem("bfoAttendeeNumber");
		this.state = {
			email: email ? email : null,
			isLoading: false,
			loadingMessage: "Searching for your information",
			errorMessage: null,
			attendee: null,
			attendeeNumber: attendeeNumber ? attendeeNumber : null,
			scheduleItems: null,
		};
	}

	componentDidMount() {
		if (this.state.attendeeNumber) {
			this.setState({ isLoading: true });
			bf.get(`/events/${eventId}/lookup?email=${encodeURIComponent(this.state.email)}`)
				.then(res => {
					let { data } = res;
					if (data.length === 0) {
						this.setState({
							isLoading: false,
							errorMessage: "We couldn't find any info for that email address",
							email: null,
						});
					}
					//else if(data.length === 1){
					//Auto choose attendee
					//}
					else {
						this.setState({ attendees: data }, () => {
							this.pickAttendee(parseInt(this.state.attendeeNumber, 10));
						});
					}
				})
				.catch(error => {
					console.log(error);
				});
		} else if (this.state.email) {
			this.updateEmail(this.state.email);
		}
	}

	submitEmail = values => {
		localStorage.setItem("bfoEmail", values.email);
		this.setState({ isLoading: true, email: values.email, errorMessage: null });
		this.updateEmail(values.email);
	};

	updateEmail = email => {
		bf.get(`/events/${eventId}/lookup?email=${encodeURIComponent(email)}`)
			.then(res => {
				let { data } = res;
				if (data.length === 0) {
					this.setState({
						isLoading: false,
						errorMessage: "We couldn't find any info for that email address",
						email: null,
					});
				} else if (data.length === 1) {
					//Auto choose attendee
					this.setState({ attendees: data }, () => {
						this.pickAttendee(data[0].AttendeeNumber);
					});
				} else {
					this.setState({ isLoading: false, attendees: data });
				}
			})
			.catch(error => {
				console.log(error);
			});
	};

	generateClassItem = (classTitle, label, extra) => {
		let parts = classTitle.split(" | ");
		let titleParts = parts[0].split(". ");
		let title = parts[0];
		if (titleParts.length > 1) {
			titleParts.shift();
			title = titleParts.join(". ");
		}
		return (
			<div className="box m-top">
				<div className="ta-left">
					{extra ? (
						<div>
							<div>
								<strong>{label}</strong>
							</div>
							<div>{extra}</div>
						</div>
					) : (
						<div>{label}</div>
					)}
				</div>
				<div>
					<h4>{title}</h4>
					<h5 style={{ opacity: 0.7 }}>
						{parts[1]} | {parts[2]}
					</h5>
				</div>
			</div>
		);
	};

	pickAttendee = attendeeNumber => {
		localStorage.setItem("bfoAttendeeNumber", attendeeNumber);
		this.setState({ attendeeNumber, isLoading: true });
		bf.get(`/attendees/${attendeeNumber}?eventId=${eventId}`)
			.then(res => {
				let attendee = res.data;
				bf.get(`/attendees/${attendeeNumber}/fields?eventId=${eventId}`)
					.then(res => {
						let { data } = res;
						// let attendee = this.state.attendees.find(attendee => {
						// 	return attendee.AttendeeNumber === attendeeNumber;
						// });
						let scheduleItems = [];
						if (attendee) {
							let typeName = attendee.TypeName.replace(/ /g, "").toLowerCase();
							switch (typeName) {
								case "superearlybird":
								case "earlybird":
								case "regular":
								case "grouprate":
								case "powertochangestaffrate":
									var selectWorkshop = data.find(field => {
										return field.Id === "35a13cd0-79f3-47ec-9a6b-03d941f02116";
									});
									if (selectWorkshop) {
										scheduleItems.push(
											this.generateClassItem(
												selectWorkshop.DisplayValue,
												"Pre-Conference Workshop",
												"Friday, January 25 9:30AM - 3:45PM"
											)
										);
									}
									var classA = data.find(field => {
										return field.Id === "0655842b-eff3-4e0b-9f9f-9686a3dc768a";
									});
									var classB = data.find(field => {
										return field.Id === "c7f9ef18-0b5c-4168-b6d2-b1226d0b5ccd";
									});
									var classC = data.find(field => {
										return field.Id === "a9e48344-f496-423f-b6cb-f89a7a3219c8";
									});
									var classD = data.find(field => {
										return field.Id === "0f5372a0-daf0-456c-ba82-9476a43017dd";
									});
									var classE = data.find(field => {
										return field.Id === "38f7c6c4-756a-48f2-aba6-e25b8133f643";
									});

									if (classA) {
										scheduleItems.push(
											this.generateClassItem(
												classA.DisplayValue,
												"Saturday, January 26th - 11:30AM"
											)
										);
									}
									if (classB) {
										scheduleItems.push(
											this.generateClassItem(
												classB.DisplayValue,
												"Saturday, January 26th - 2:00PM"
											)
										);
									}
									if (classC) {
										scheduleItems.push(
											this.generateClassItem(
												classC.DisplayValue,
												"Saturday, January 26th - 3:00PM"
											)
										);
									}
									if (classD) {
										scheduleItems.push(
											this.generateClassItem(classD.DisplayValue, "Sunday, January 27th - 8:30AM")
										);
									}
									if (classE) {
										scheduleItems.push(
											this.generateClassItem(
												classE.DisplayValue,
												"Sunday, January 27th - 10:00AM"
											)
										);
									}

									break;

								case "superearlybird|student":
								case "earlybird|student":
								case "regular|student":
									var selectWorkshopStudent = data.find(field => {
										return field.Id === "ad1a6d30-efdf-45ec-b185-2ec79d464e24";
									});
									if (selectWorkshopStudent) {
										scheduleItems.push(
											this.generateClassItem(
												selectWorkshopStudent.DisplayValue,
												"Pre-Conference Workshop",
												"Friday, January 25 9:30AM - 3:45PM"
											)
										);
									}
									var classAStudent = data.find(field => {
										return field.Id === "0655842b-eff3-4e0b-9f9f-9686a3dc768a";
									});
									var classBStudent = data.find(field => {
										return field.Id === "c7f9ef18-0b5c-4168-b6d2-b1226d0b5ccd";
									});
									var classCStudent = data.find(field => {
										return field.Id === "a9e48344-f496-423f-b6cb-f89a7a3219c8";
									});
									var classDStudent = data.find(field => {
										return field.Id === "0f5372a0-daf0-456c-ba82-9476a43017dd";
									});
									var classEStudent = data.find(field => {
										return field.Id === "38f7c6c4-756a-48f2-aba6-e25b8133f643";
									});

									if (classAStudent) {
										scheduleItems.push(
											this.generateClassItem(
												classAStudent.DisplayValue,
												"Saturday, January 26th - 11:30AM"
											)
										);
									}
									if (classBStudent) {
										scheduleItems.push(
											this.generateClassItem(
												classBStudent.DisplayValue,
												"Saturday, January 26th - 2:00PM"
											)
										);
									}
									if (classCStudent) {
										scheduleItems.push(
											this.generateClassItem(
												classCStudent.DisplayValue,
												"Saturday, January 26th - 3:00PM"
											)
										);
									}
									if (classDStudent) {
										scheduleItems.push(
											this.generateClassItem(
												classDStudent.DisplayValue,
												"Sunday, January 27th - 8:30AM"
											)
										);
									}
									if (classEStudent) {
										scheduleItems.push(
											this.generateClassItem(
												classEStudent.DisplayValue,
												"Sunday, January 27th - 10:00AM"
											)
										);
									}

									break;
								case "superearlybird|pre-conferenceworkshoponly":
								case "earlybird|pre-conferenceworkshoponly":
								case "regular|pre-conferenceworkshoponly":
								case "student|pre-conferenceworkshoponly":
									var selectWorkshopOnly = data.find(field => {
										return field.Id === "7bdf13c0-a136-472b-bb46-b111a7408b35";
									});
									if (selectWorkshopOnly) {
										scheduleItems.push(
											this.generateClassItem(
												selectWorkshopOnly.DisplayValue,
												"Pre-Conference Workshop",
												"Friday, January 25 9:30AM - 3:45PM"
											)
										);
									}
									break;
								default:
									break;
							}
							this.setState({ scheduleItems, isLoading: false, attendee }, () => {
								setTimeout(() => {
									window.scrollTo(0, 0);
								}, 0);
							});
						}
						if (data.length === 0) {
							this.setState({
								isLoading: false,
								errorMessage: "We couldn't find any info for that email address",
								email: null,
							});
						}
					})
					.catch(() => {
						this.setState({
							isLoading: false,
							errorMessage: "We couldn't find any info for that attendee",
							email: null,
						});
					});
			})
			.catch(() => {
				this.setState({
					isLoading: false,
					errorMessage: "We couldn't find any info for that attendee",
					email: null,
				});
			});
	};

	generateAttendeePicker = () => {
		if (this.state.attendees) {
			return this.state.attendees.map(attendee => {
				return (
					<div
						key={attendee.AttendeeNumber}
						className="attendeePicker box"
						onClick={() => {
							this.pickAttendee(attendee.AttendeeNumber);
						}}
					>
						{attendee.FirstName} {attendee.LastName}
					</div>
				);
			});
		}
		return null;
	};

	switchUser = () => {
		this.setState({ email: null, attendeeNumber: null, attendee: null });
	};

	render() {
		const {
			email,
			isLoading,
			loadingMessage,
			errorMessage,
			attendees,
			attendee,
			attendeeNumber,
			scheduleItems,
		} = this.state;
		const timezoneOptions = [];
		if (this.props.timezones) {
			this.props.timezones.forEach(timezone => {
				timezoneOptions.push({
					key: timezone.id,
					value: timezone.id,
					label: timezone.name,
				});
			});
		}
		let attendeePicker = this.generateAttendeePicker();

		return (
			<div className="log-in-window" style={{ backgroundImage: "none", padding: 0, boxShadow: "none" }}>
				<div className="log-in-window-content">
					<div className="" style={{}}>
						{isLoading ? (
							<div>
								<Loader />
								<div className="small">{loadingMessage}</div>
							</div>
						) : (
							<div>
								{errorMessage && <div className="error">{errorMessage}</div>}
								{email ? (
									<div>
										{attendees && !attendeeNumber && (
											<div>
												<h3 className="page-title">{"Pick Your Attendee"}</h3>
												{attendeePicker}
											</div>
										)}
										{attendeeNumber && attendee && (
											<div style={{ maxWidth: "800px" }}>
												<div className="row" style={{ marginBottom: "15px" }}>
													<div className="col-sm-12">
														<h3>
															Schedule For {attendee.FirstName} {attendee.LastName}
														</h3>
													</div>
													<div className="col-sm-4" style={{ marginTop: "10px" }}>
														<div
															className="btn btn-primary wide"
															style={{ backgroundColor: "#ee4147" }}
															onClick={this.switchUser}
														>
															Switch Attendee
														</div>
													</div>
													<div className="col-sm-4" style={{ marginTop: "10px" }}>
														<a
															href={`https://breakforthone.brushfire.com/edmonton/443857/my-attendees?attendee=${attendee.Id}`}
															target="_blank"
														>
															<div className="btn btn-primary wide">Edit Attendee</div>
														</a>
													</div>
													<div className="col-sm-4" style={{ marginTop: "10px" }}>
														<div
															className="btn btn-primary wide"
															style={{ backgroundColor: "#9dd5c1" }}
															onClick={() => this.pickAttendee(attendeeNumber)}
														>
															Refresh
														</div>
													</div>
												</div>

												{scheduleItems}
											</div>
										)}
									</div>
								) : (
									<div>
										<h3 className="page-title">{"Let's find your schedule"}</h3>
										<Form onSubmit={this.submitEmail}>
											<TextInput
												field="email"
												id="email"
												placeholder="Email Address"
												isRequired
												validationRegex={constants.EMAIL}
											/>
											<button className="btn wide btn-primary">Search</button>
										</Form>
									</div>
								)}
							</div>
						)}
					</div>
				</div>
			</div>
		);
	}
}
BreakForthOneSchedule.propTypes = {
	match: PropTypes.any,
	timezones: PropTypes.any,
	history: PropTypes.any,
};

function mapStateToProps(state) {
	return {
		timezones: state.controlPanel.timezones,
	};
}

export default connect(mapStateToProps)(BreakForthOneSchedule);
